import {useGetUserPreferencesQuery} from 'services/userPreferences';
import type {ShortcutCommand, ShortcutUserPreference} from '../types';

/**
 * Hook to get a user's user preference for a specific shortcut command.
 */
export const useShortcutUserPreference = (
  command: ShortcutCommand,
  defaultValue: string | undefined,
) => {
  return useGetUserPreferencesQuery('shortcut', {
    selectFromResult: ({data}) => ({
      userPreference:
        (data?.find(
          item =>
            item.name === command &&
            item.category === 'shortcut' &&
            item.type === 'USER_SPECIFIC',
        ) as ShortcutUserPreference) ??
        ({
          name: command,
          value: defaultValue,
          category: 'shortcut',
          type: 'USER_SPECIFIC',
        } as ShortcutUserPreference),
    }),
  });
};
